import { type FlexProps } from "@chakra-ui/react";
import { OperationTypes, type Transaction } from "@umami/chains";
import { memo } from "react";

import { TransactionTile } from "./TransactionTile";

export const OperationTile = memo(
  ({ operation, ...props }: { operation: Transaction } & FlexProps) => {
    switch (operation.operationType) {
      case OperationTypes.TRANSACTION:
      case OperationTypes.TOKEN_TRANSFER:
      case OperationTypes.SAFE_SEND:
      case OperationTypes.TOKEN_BURNING:
      case OperationTypes.TOKEN_MINTING:
      case OperationTypes.SHIELD:
      case OperationTypes.UNSHIELD:
      case OperationTypes.SAPLING: {
        return <TransactionTile operation={operation} {...props} />;
      }
      case OperationTypes.CONTRACT_CALL: {
        // TODO: Implement contract call tile
        return null;
      }

      // TODO: Implement rest of the operation tiles if needed
      // case "delegation":
      //   return <DelegationTile operation={operation} {...props} />;

      // case "origination":
      //   return <OriginationTile operation={operation} {...props} />;

      // case "stake":
      //   return <StakeTile operation={operation} {...props} />;

      // case "unstake":
      //   return <UnstakeTile operation={operation} {...props} />;

      // case "finalize":
      //   return <FinalizeUnstakeTile operation={operation} {...props} />;
    }
  }
);
